import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { changePatientResource } from 'redux/modules/patients';

import OrderInformationSection from 'components/workflow/OrderInformation/OrderInformationSection';
import ReferralSourceCreateEditDialog from 'components/settings/ReferralSourceCreateEditDialog';
import ReferralSourceAddDialog from 'components/patient/PatientProfile/ReferralSource/ReferralSourceAddDialog';

import OrderInformationReferralSourceSelection from './OrderInformationReferralSourceSelection';
import OrderInformationReferralSourceEmpty from './OrderInformationReferralSourceEmpty';

class OrderInformationReferralSource extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addDialogOpen: false,
      createDialogOpen: false,
    };

    this.onAddButtonClick = this.onAddButtonClick.bind(this);
    this.onAddDialogClose = this.onAddDialogClose.bind(this);
    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
  }

  onAddButtonClick() {
    this.setState({ addDialogOpen: true });
  }

  onAddDialogClose() {
    this.setState({ addDialogOpen: false });
  }

  onCreateButtonClick() {
    this.setState({
      addDialogOpen: false,
      createDialogOpen: true,
    });
  }

  onCreateDialogClose() {
    this.setState({ createDialogOpen: false });
  }


  render() {
    const { Patient, actions, change, formValues, disabled } = this.props;
    const { addDialogOpen, createDialogOpen } = this.state;
    return (
      <OrderInformationSection>
        {Patient['Referral Source'].length > 0 ? (
          <OrderInformationReferralSourceSelection
            {...{ 'Referral Source': Patient['Referral Source'] }}
            onAddButtonClick={this.onAddButtonClick}
            change={change}
            disabled={disabled}
          />
        ) : (
          <OrderInformationReferralSourceEmpty
            onAddButtonClick={this.onAddButtonClick}
            disabled={disabled}
          />
        )}
        <ReferralSourceAddDialog
          open={addDialogOpen}
          onClose={this.onAddDialogClose}
          onCreateButtonClick={this.onCreateButtonClick}
          onSubmitSuccess={(values) => {
            this.onAddDialogClose();
            new Promise((resolve, reject) => {
              actions.changePatientResource({
                'Record Number': Patient['Record Number'],
                'Referral Source': [
                  { id: values.ID },
                  ...Patient['Referral Source'].map(item => ({ id: item.ID })),
                ],
                resolve,
                reject,
              });
            }).then(() => {
              change('Referral Source Name', values.Name);
              change('Selected Referral Source Name', values.Name);
              change('Referral Source ID', values.ID);
            });
          }}
          formValues={formValues}
        />
        <ReferralSourceCreateEditDialog
          form="referralSourceCreate"
          open={createDialogOpen}
          onClose={this.onCreateDialogClose}
          onSubmitSuccess={values => (
            new Promise((resolve, reject) => {
              actions.changePatientResource({
                'Record Number': Patient['Record Number'],
                'Referral Source': [
                  { id: values.ID },
                  ...Patient['Referral Source'].map(item => ({ id: item.ID })),
                ],
                resolve,
                reject,
              });
            }).then(() => {
              change('Referral Source Name', values['Name of source']);
              change('Selected Referral Source Name', values['Name of source']);
              change('Referral Source ID', values.ID);
            })
          )}
        />
      </OrderInformationSection>
    );
  }
}

OrderInformationReferralSource.propTypes = {
  change: PropTypes.func.isRequired,
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    changePatientResource: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  disabled: PropTypes.bool,
};

OrderInformationReferralSource.defaultProps = {
  formValues: {},
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ changePatientResource }, dispatch),
});

export default connect(null, mapDispatchToProps)(OrderInformationReferralSource);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationReferralSource/OrderInformationReferralSource.js